"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantCurrency = void 0;
const getOrderLineCurrency_1 = require("./getOrderLineCurrency");
const getVariantCurrency = (variant) => {
    if (!variant)
        return " - ";
    if (!variant.order_lines || variant.order_lines.length === 0)
        return " - ";
    // sort lines by type,  TRANSFERS, GOLF, HOTELS, EXCURSIONS
    const type_order = ["TRANSFERS", "GOLF", "HOTELS", "EXCURSIONS"];
    const lines = variant.order_lines.sort((a, b) => type_order.indexOf(a.type) - type_order.indexOf(b.type));
    for (const line of lines) {
        const currency = (0, getOrderLineCurrency_1.getOrderLineCurrency)(line);
        if (currency) {
            return currency;
        }
    }
    return null;
};
exports.getVariantCurrency = getVariantCurrency;
